<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        {{title}}
      </p>
    </header>
    <div class="card-content">
      <div v-if="date" class="content">
        Date:
        <time :datetime="date.format('DD-MMMM-YYYY')">{{prettyDate}}</time>
      </div>
      <div v-if="isAccess" class="content">
        Partenaire : {{event.company_name}} Programme : {{event.program_name}}
      </div>
    </div>
    <footer class="card-footer">
      <a @click="editRdv" class="card-footer-item" v-if="isRdv">Editer</a>
      <a @click="deleteEvent" class="card-footer-item" v-if="!isReminder">Supprimer</a>
    </footer>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'CalendarEventItem',
    props: {
      event: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    data () {
      return {}
    },
    computed: {
      isRdv () {
        return this.type === 'RDV'
      },
      isOption () {
        return this.type === 'OPTION'
      },
      isAccess () {
        return this.type === 'ACCESS'
      },
      isReminder () {
        return this.type === 'REMINDER'
      },
      title () {
        if (this.isRdv) {
          return this.event.title
        } else if (this.isOption) {
          let lotRef = this.event.lot_ref
          let sellerName = this.event.seller_name
          return `Option sur le lot ${lotRef} par le vendeur ${sellerName}`
        } else if (this.isAccess) {
          return 'Expiration du mandat'
        } else if (this.isReminder) {
          let title = this.event.title
          let note = this.event.note
          let user = this.event.user_name
          return `Rappel : "${title}" pour ${user}. ${note ? ' Note: ' + note : ''}`
        } else {
          return 'unknow event'
        }
      },
      prettyDate () {
        if (this.date) {
          return this.date.format('[Le] DD/MMMM [à] HH:mm')
        }
      },
      date () {
        let date
        if (this.isRdv || this.isReminder) {
          date = moment(this.event.date)
        } else if (this.isOption) {
          date = moment(this.event.end_date)
        } else if (this.isAccess) {
          date = moment(this.event.end_date, 'DD/MM/YYYY')
        }

        if (date && date.isValid()) {
          return date
        } else {
          return null
        }
      }
    },
    methods: {
      deleteEvent () {
        this.confirmDelete().then(r => {
          if (r.value) {
            this.$emit('delete-event', this.event)
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Erreur lors de la suppression'
            })
          }
        })
      },
      confirmDelete () {
        return this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer cet élément ?',
          confirmButtonText: 'Supprimer'
        })
      },
      editRdv () {
        let params = {
          source: this.event
        }
        this.$store.commit('setQuickview', {mode: 'NEW_CALENDAR_ACTION', params: params})
        // this.$router.push({name: 'CalendarEdit', params: {id: this.event.pk}})
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarEventItem.vue